<template>
  <div class="sessionless" :class="getSessionlessClasses">
    <p class="title" :class="getSessionlessTitleClasses">{{ title }}</p>
    <p class="subtitle" :class="topBarView ? 'sessionless--topBarView-subtitle' : ''" v-if="$windowWidth > 700">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "NoBookings",
  props: {
    topBarView: Boolean,
  },
  computed: {
    title() {
      if (this.$windowWidth > 800) {
        return `You don't have any upcoming sessions this week.`;
      } else if (this.$windowWidth <= 800) {
        return `Book some sessions to kickstart your productivity!`;
      }
      return ``;
    },
    subtitle() {
      if (this.$windowWidth > 800) {
        return `Book some to kickstart your productivity!`;
      }
      return ``;
    },
    getSessionlessClasses() {
      let classes = "";
      if (this.topBarView) {
        classes += "sessionless--topBarView" + " ";
      }
      if (this.$isMobile) {
        classes += "sessionless--mobile" + " ";
      }
      return classes;
    },
    getSessionlessTitleClasses() {
      let classes = "";
      if (this.topBarView) {
        classes += "sessionless--topBarView-title" + " ";
      }
      if (this.$isMobile) {
        classes += "sessionless--title--mobile" + " ";
      }
      return classes;
    },
  },
};
</script>

<style scoped>
.sessionless--mobile {
  padding: 8px;
}
.sessionless--title--mobile {
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-right: unset;
}
</style>
